.container {
  border-radius: var(--border-radius-sm);
  color: var(--color-neutral-60);
  font-size: smaller;
  font-weight: var(--font-weight-medium);
  height: 36px;
  padding-right: 6px;
  padding-left: 6px;
}

.achieved {
  background-color: #dffdeb;
}

.notAchieved {
  background-color: #ffeae9;
}

.inProgress {
  background-color: #e0e0e0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL2NvbW1vbi9jb21wb25lbnRzL2ludGVybmFsL01ldGFEYXkiLCJzb3VyY2VzIjpbIk1ldGFEYXkubW9kdWxlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRTs7O0FBR0Y7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi5jb250YWluZXIge1xuICBib3JkZXItcmFkaXVzOiB2YXIoLS1ib3JkZXItcmFkaXVzLXNtKTtcbiAgY29sb3I6IHZhcigtLWNvbG9yLW5ldXRyYWwtNjApO1xuICBmb250LXNpemU6IHNtYWxsZXI7XG4gIGZvbnQtd2VpZ2h0OiB2YXIoLS1mb250LXdlaWdodC1tZWRpdW0pO1xuICBoZWlnaHQ6IDM2cHg7XG4gIHBhZGRpbmctcmlnaHQ6IDZweDtcbiAgcGFkZGluZy1sZWZ0OiA2cHg7XG59XG5cbi5hY2hpZXZlZCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNkZmZkZWI7XG59XG5cbi5ub3RBY2hpZXZlZCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNmZmVhZTk7XG59XG5cbi5pblByb2dyZXNzIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2UwZTBlMDtcbn0iXX0= */